import { Link } from "react-router-dom";
import { ArrowRight, ArrowLeft } from "lucide-react";
import { Navbar } from "../components/Navbar";
import { Footer } from "../components/Footer";
import { LOGO_TYPES } from "../data/site";

export default function LogoTypes() {
  return (
    <div className="App">
      <Navbar />

      {/* HEADER */}
      <section className="bg-[#1F2530] text-[#F3F4F6] py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <Link
            to="/"
            data-testid="logo-types-back"
            className="inline-flex items-center gap-2 text-sm font-bold uppercase tracking-[0.15em] text-[#F3F4F6]/70 hover:text-[#7BA7D9] transition-colors"
          >
            <ArrowLeft size={16} strokeWidth={2.5} /> Back home
          </Link>
          <span className="block mt-8 text-xs font-bold uppercase tracking-[0.2em] text-[#7BA7D9]">
            Business Logos
          </span>
          <h1 className="font-display text-5xl sm:text-7xl leading-[0.95] mt-3">
            Types of Logos We Design
          </h1>
          <p className="mt-5 max-w-2xl text-lg font-medium text-[#F3F4F6]/70">
            Every brand deserves a logo that reflects its unique identity. Explore our
            nine professionally crafted logo styles, with pricing starting at{" "}
            <span className="font-bold text-[#7BA7D9]">$49</span>,{" "}
            <span className="font-bold text-[#7BA7D9]">$69</span>,{" "}
            <span className="font-bold text-[#7BA7D9]">$89</span>, and{" "}
            <span className="font-bold text-[#7BA7D9]">$99</span>—designed to fit every
            vision and budget.
          </p>
        </div>
      </section>

      {/* LOGO TYPES GRID */}
      <section className="bg-[#F3F4F6] py-20 sm:py-28">
        <div className="max-w-7xl mx-auto px-6 sm:px-10">
          <div
            className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6"
            data-testid="logo-types-grid"
          >
            {LOGO_TYPES.map((t) => (
              <div
                key={t.name}
                data-testid={`logo-type-${t.name.toLowerCase().replace(/\s+/g, "-")}`}
                className="brutal-border brutal-shadow-sm brutal-press bg-white p-6 flex flex-col"
              >
                <div className="flex items-center justify-between gap-3">
                  <h3 className="font-display text-2xl text-[#1F2530]">{t.name}</h3>
                  <span className="shrink-0 text-xs font-bold uppercase tracking-wider bg-[#EAF1F8] text-[#3E6FA8] px-2.5 py-1 rounded-full">
                    From ${t.price || 49}
                  </span>
                </div>
                <p className="mt-3 leading-relaxed text-[#1F2530]/70 flex-1">{t.desc}</p>
                <Link
                  to="/contact"
                  state={{ service: `Business Logos — ${t.name}` }}
                  data-testid={`logo-type-order-${t.name.toLowerCase().replace(/\s+/g, "-")}`}
                  className="mt-5 inline-flex items-center gap-1.5 self-start font-semibold text-sm text-[#3E6FA8] hover:gap-3 transition-all"
                >
                  Order this <ArrowRight size={16} strokeWidth={2.5} />
                </Link>
              </div>
            ))}
          </div>

          {/* CTA */}
          <div className="mt-14 brutal-border brutal-shadow bg-white p-8 sm:p-10 flex flex-col sm:flex-row sm:items-center sm:justify-between gap-6">
            <div>
              <h2 className="font-display text-3xl sm:text-4xl text-[#1F2530]">
                Not sure which style fits?
              </h2>
              <p className="mt-2 font-medium text-[#1F2530]/70">
                Tell us about your brand and we'll recommend the perfect logo type.
              </p>
            </div>
            <Link
              to="/contact"
              data-testid="logo-types-cta"
              className="shrink-0 inline-flex items-center gap-3 brutal-border brutal-shadow-sm brutal-press bg-[#3E6FA8] text-white font-extrabold uppercase tracking-wider px-7 py-4"
            >
              Start Your Order <ArrowRight size={20} strokeWidth={2.5} />
            </Link>
          </div>
        </div>
      </section>

      <Footer />
    </div>
  );
}
